import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

interface LogoProps {
  size?: number;
  className?: string;
  showText?: boolean;
}

export function Logo({ size = 32, className = '', showText = true }: LogoProps) {
  const { currentTheme } = useTheme();

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div 
        className="flex items-center justify-center"
        style={{ 
          width: size, 
          height: size,
          backgroundColor: currentTheme.colors.primary,
          borderRadius: '8px'
        }}
      >
        <img 
          src="/logo.png" 
          alt="SnapShift Logo" 
          className="w-full h-full object-contain p-1"
          style={{ filter: 'brightness(0) invert(1)' }} // Make logo white
        />
      </div>
      {showText && (
        <span className="font-bold text-lg" style={{ color: currentTheme.colors.primary }}>
          SnapShift
        </span>
      )}
    </div>
  );
}
